export default __webpack_public_path__ + "terrain-map-800-84eb4574dd371434e0ae6507ae02e487.png";